var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    上传组件\n    "),_c('img-upload',{attrs:{"imgList":_vm.imgList},on:{"upLoadImg":_vm.upLoadImg,"deleteImg":_vm.deleteImg}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }